<template>
  <div class="home">
    <h3 style="color: rgba(21, 101, 192, 0.8); text-align: center">
      {{ randomItem }}
    </h3>
    <hr />
    <v-btn @click="handleClick('/note')" class="btn">Blog</v-btn>
    <v-btn
      @click="
        handleClick('/about')
      "
      class="btn"
      >关于我</v-btn
    >
    <hr />
  </div>
</template>

<script>
export default {
	name: "home",
	data() {
		return {
			items: [
				"立于皓月之间，不弱星光之势  傍于巨人身侧，不颓好胜之心",
				"老人挨着墙根晒着太阳，我看失落她却平常”——《出城》",
				"生命中曾经拥有过的所有灿烂，原来终究，都要用寂寞来偿还。——马尔克斯《百年孤独》",
				"难怪我遇风潸然泪下，竟是你寄风万里的思念",
				"世界上只有一种真正的英雄主义，就是看透生活的本质之后依然热爱生活",
				"一束光打进房子，让人看到希望，也会照见灰尘。",
				"人生在世，吞炭饮冰",
				"枯木逢春犹再发，人无两度再少年",
				"科学技术包含了这个世界最大的善意，把人从琐碎劳动中解放出来，缩短了空间和时间的距离，让信息触手可及，知识得以传播。“懒惰”才是人类文明进步的阶梯，而技术使人谦卑。科技是唯一能够产生可叠加式收益的进步力量，历史会重演而科技永远向前。",
				"一辈子很短，如白驹过隙，转瞬即逝。可这种心情很长，如高山大川，绵延不绝。",
				"骤雨反复，春梦无痕",
				"“我不常提起亚瑟，但我真的想念他”",
				"歌的好坏与热度无关，人的好恶却受其影响。人常常有一种小众情节或是大众情节。火就听，和火就不听都是很常见的。圈子不同，出现这两种情况的概率就不一样。沉浸小众文化的偏向后者，偏好大众趣味的会偏向前者。",
				"学习，从出生的那一刻起就未曾停止过，只是有的人学得越来越差，有的人学得越来越好。于是乎，人生命运就像相交的两条不平行直线，渐行渐远。",
				"人一到群体中，智商就严重降低，为了获得认同，个体愿意抛弃是非，用智商去换取那份让人备感安全的归属感。 ——古斯塔夫·勒庞 《乌合之众》",
				"三千年读史，不外功名利禄。九万里悟道，终归诗酒田园。",
				"三十功名尘与土，八千里路云和月",
				"难道因为人生短暂就要不留痕迹的虚度一生？虽然在雪地上踏足的印记终究会消失，但不妨碍我们努力的寻求生活的意义，感受生命，留下来过的足迹。",
				"薄纸只能遮住遗憾，风一吹，睁开眼一看，缺口还是在那里。我们能做的，只有珍视眼前人，改变不了过去，弥补不了缺失。",
				"我们讲究，实事求是",
				"“回头看，轻舟已过万重山，向前看，长路漫漫亦灿烂”",
				"风雪压我两三年，我笑风轻雪如绵。",
				"不公正，哪怕有利于我的，长远来看必有害于我",
				"事实不以人的意志为转移，感情不以人的期盼作发展。",
				"秋风萧萧，夕阳垂照，又是一年。",
				"遇贵人先立业，遇良人先成家。无贵人且自立，无良人且修身",
				"每个人都遵循自己的规矩，为自己的前途着想，做利己主义，但是爱会让人不清醒，会让人付出让人奉献让人神魂颠倒不知所以，原来“凡人百年，爱是秩序外的一瞬间”",
				"旧日种种，如川而逝",
				"事有机缘，不先不后，刚刚凑巧；命若蹭蹬，走来走去，步步踏空。",
				"岁月悠悠，衰微只及肌肤；热忱抛却，颓唐必致灵魂。",
				"此生何用声声叹",
				"无论人生上到哪一层台阶，阶下有人在仰望你，阶上亦有人在俯视你。你抬头自卑，低头自得，唯有平视，才能看见真实的自己。",
				"孤独是每个人身体的一部分，你要做的不是摆脱它，而是和它和平相处，只有那样，你才会明白你其实一无所有，也就不再害怕失去。",
				"有的人想睡觉，但不是因为困倦，而是出于对睡觉的怀念。",
				"自己是森林才能读懂森林，为了感受大海就必须成为大海。",
				"春风若有怜花意，可否许我再少年",
				"万般刑具任你挑，杀我别用感情刀",
				"但是太阳，它每时每刻都是夕阳也都是旭日。当它熄灭着走下山去收尽苍凉残照之际，正是它在另一面燃烧着爬上山巅布散烈烈朝辉之时。那一天，我也将沉静着走下山去，扶着我的拐杖。有一天，在某一处山洼里，势必会跑上来一个欢蹦的孩子，抱着他的玩具。当然，那不是我。但是，那不是我吗？宇宙以其不息的欲望将一个歌舞炼为永恒。这欲望有怎样一个人间的姓名，大可忽略不计。",
				"积德无需人见，行善自有天知！",
				"已有的事后必再有,已行的事后必再行。日光之下并无新事。",
				"和昨天的自己诀别，和今天的自己前进，和明天的自己和解",
				"迷雾是光明的前奏，也是你非凡人生的序幕。",
				"困扰我们的，不是如何过上更幸福的生活，而是如何过上比别人更幸福的生活——生活最本质的博弈。",
				"给你一颗回春丹 逃出苦难向春山",
				"沧浪之水清兮，可以濯吾缨；沧浪之水浊兮，可以濯吾足。",
			],
		};
	},
	methods: {
		handleClick: function(url) {
			if (url.indexOf("http") != -1) {
				window.open(url, "_blank");
			} else {
				this.$router.push(url);
			}
		},
	},
	computed: {
		randomItem() {
			return this.items[Math.floor(Math.random() * this.items.length)];
		},
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	position: absolute;
	padding: 0;
}
.btn {
	background-color: rgba(21, 101, 192, 0.8) !important;
	color: white;
	text-transform: none;
}
hr {
	width: 100%;
	background-color: rgba(21, 101, 192, 0.8);
	height: 3px;
	margin: 20px;
}
</style>
